import type { UrlEntry, UrlRegion } from '@/types';

export const urls: Record<'financing', Record<UrlRegion, UrlEntry>> = {
  financing: {
    de: 'finanzierung',
    'de-en': 'financing-options',
    es: 'financiacion',
    'es-en': 'financing-options',
    fr: 'option-de-financement',
    'fr-en': 'financing-options',
    gb: 'financing-options',
    nl: 'financiering',
    'nl-en': 'financing-options',
    pt: 'financiamento',
    'pt-en': 'financing-options',
    us: 'financing',
    ww: 'financing-options',
  },
};
